"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditOffer = void 0;
var react_1 = __importDefault(require("react"));
var CreditOffer_module_scss_1 = __importDefault(require("./CreditOffer.module.scss"));
var react_redux_1 = require("react-redux");
var CreditBankProgram_1 = require("../creditBankProgram/CreditBankProgram");
var CreditBankInfo_1 = require("../creditBankInfo/CreditBankInfo");
var selectors_1 = require("../../redux/selectors");
var CreditOffer = function (_a) {
    var bank = _a.bank, payment = _a.payment;
    var _b = react_1.default.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var targetProgram = (0, react_redux_1.useSelector)(selectors_1.banksListSelector).targetProgramId;
    var handlerCreditOffer = function () {
        setIsOpen(function (prev) { return !prev; });
    };
    var isTargetProgram = function () {
        return bank.programs.some(function (program) { return program.id === targetProgram; });
    };
    return (react_1.default.createElement("article", { className: "".concat(CreditOffer_module_scss_1.default.offer, " ").concat(isOpen ? CreditOffer_module_scss_1.default.offer_active_open : '', " ").concat(isTargetProgram() ? CreditOffer_module_scss_1.default.offer_active_program : '') },
        react_1.default.createElement(CreditBankInfo_1.CreditBankInfo, { bank: bank, isOpen: isOpen, handler: handlerCreditOffer, payment: payment }),
        react_1.default.createElement("div", { className: CreditOffer_module_scss_1.default.offer__programs, style: { maxHeight: "".concat(isOpen ? 250 : 0, "px") } }, bank.programs.map(function (program) {
            return react_1.default.createElement(CreditBankProgram_1.CreditBankProgram, { key: program.id, program: program });
        }))));
};
exports.CreditOffer = CreditOffer;
